export default class Cliente {
    constructor(_id, dtInclusao, CNPJ, CPF, xNome, IE, qtd, vlrMin, vlrMax, dtPrimeiraCompra, dtUltimaCompra,qntServico, customValues, enderEmit,nfes,conta) {

        this.xNome = xNome,
        this.CNPJ = CNPJ != undefined ? CNPJ : CPF != undefined ? CPF : undefined,
            this.Tipo = this.trabFiliado = qtd > 0 && qntServico > 0 ? 'nfe_nfse' : qtd > 0 && qntServico == 0 ? 'nfe' : 'nfse',
            this.dtInclusao = new Date(dtInclusao),
            this.enderEmit = enderEmit,

            this.IE = IE,
            this.qtd = qtd,
            this.vlrMin = vlrMin,
            this.vlrMax = vlrMax,
            this.dtPrimeiraCompra = new Date(dtPrimeiraCompra),
            this.dtUltimaCompra = new Date(dtUltimaCompra),
            this.qntServico = qntServico,
            this._id = _id,
            this.customValues = customValues,
            this.nfes = nfes,
            this.conta = conta


    }
}





// WEBPACK FOOTER //
// ./src/domain/clientes/Clientes.js